import {Component, Input} from '@angular/core';
import {
  FilterService,
  BaseFilterCellComponent,
} from '@progress/kendo-angular-grid';

@Component({
    selector: 'app-form-status-filter',
    template: `
    <kendo-dropdownlist
      [data]='data'
      (valueChange)='onChange($event)'
      [defaultItem]='defaultItem'
      [value]='selectedValue'
      [valuePrimitive]='true'
      [textField]='textField'
      [valueField]='valueField'
    >
    </kendo-dropdownlist>
  `,
    standalone: false
})
export class FormStatusFilterComponent extends BaseFilterCellComponent {
  public get selectedValue(): any {
    const filter = this.filterByField(this.valueField);
    return filter ? filter.value : null;
  }

  @Input() public override filter: any;
  @Input() public data: any[];
  @Input() public textField: string;
  @Input() public valueField: string;
  @Input() public table: string;

  public get defaultItem(): any {
    return {
      [this.textField]: 'Not Processed',
      [this.valueField]: 'not_processed',
    };
  }

  constructor(filterService: FilterService) {
    super(filterService);
  }

  public onChange(value: any): void {
    console.log('inside form status filter');
    this.applyFilter(
      value === null || value === '' // value of the default item
        ? this.removeFilter('status') // remove the filter
        :
        this.updateFilter({
          // add a filter for the field with the value
          field: 'status',
          operator: 'eq',
          value,
        })
    ); // update the root filter
  }
}
